import { SectionHeading } from './SectionHeading'

// "Testimonials" — 4 quotes in a 2×2 grid on desktop, 1-col on mobile
// (#7r2). Static grid by dispatch decision (no slick-carousel
// dependency; accessibility wins; all quotes visible at once).
//
// Curly quotes around the body (matches marketing's "…"); attribution
// in gold with em-dash prefix.

const TESTIMONIALS: Array<{ quote: string; name: string }> = [
  { quote: 'This is Interesting & very useful to connect with relatives.', name: 'Kalidas, US' },
  { quote: 'A truly private network – I feel safe sharing stories.',       name: 'Nikhil, Bengaluru' },
  { quote: "Best tool I've used to build our family tree!",                name: 'Sai, Hyderabad' },
  { quote: 'I love how easy it is to connect with extended relatives.',    name: 'Prasad, Hyderabad' },
]

export function TestimonialsSection() {
  return (
    <section className="py-12 sm:py-16 px-4">
      <div className="max-w-4xl mx-auto">
        <SectionHeading id="testimonials">Testimonials</SectionHeading>
        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-5">
          {TESTIMONIALS.map((t) => (
            <figure
              key={t.name}
              className="bg-navy text-white rounded-xl p-5 shadow-[0_4px_10px_rgba(0,0,0,0.4)] border border-white/5 flex flex-col justify-between"
            >
              <blockquote className="text-white/95 text-sm sm:text-base leading-relaxed">
                <span className="text-gold mr-1">&ldquo;</span>
                {t.quote}
                <span className="text-gold ml-1">&rdquo;</span>
              </blockquote>
              <figcaption className="text-gold text-sm font-semibold text-right mt-3">— {t.name}</figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  )
}
